/* eslint-disable @typescript-eslint/no-magic-numbers */
export enum StepNumberEnum {
  Compatibility = 1,
  SoftwareLicenseAgreement = 2,
  InstallationPending = 3,
  ServerInstallationChecklist = 4,
  ServerInstallationDownload = 5,
  PracticeManager = 6,
  // Appended (not inserted) to avoid shifting persisted contract.step values for existing users.
  // These two steps come *before* ServerInstallationChecklist in the flow; ordering is handled
  // explicitly in determineNextStep(), not by numeric order.
  ItProviderDetails = 7,
  InstallOptions = 8,
  // Terminal step for the "contact my IT team" path: a persisted, read-only confirmation screen so
  // reloading /setup resumes here instead of re-offering the install options (which would re-submit).
  ItProviderContacted = 9,
}
